module.exports = __webpack_public_path__ + "static/media/registryIcon.aee7e216.svg";